import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ArabicBreadcrumbs from "../common/ArabicBreadcrumbs";
import { setMeta } from "../../core/data/utils/meta";
import { CLIENT_BASE_PATH } from "../../environment";

const faqItems = [
  {
    question: "كيف يمكنني حجز رحلة العمرة معكم؟",
    answer:
      "يمكنك حجز رحلتك من خلال موقعنا الإلكتروني أو تطبيق الهاتف. اختر الباقة التي تريدها، أدخل بياناتك، واختر طريقة الدفع. سيتم إرسال تأكيد الحجز إليك فوراً بعد إتمام الحجز."
  },
  {
    question: "ما أنواع الباقات التي تقدمونها لرحلة العمرة؟",
    answer:
      "نقدم مجموعة متنوعة من الباقات لتناسب احتياجات وميزانيات مختلفة، تشمل باقات أساسية ومميزة وفاخرة. تشمل كل باقة السفر والإقامة ومعالجة التأشيرة، مع تفاصيل كاملة متوفرة على موقعنا."
  },
  {
    question: "هل يمكنكم تلبية الطلبات أو الاحتياجات الخاصة؟",
    answer:
      "نعم، نسعى لتلبية جميع الطلبات الخاصة، بما في ذلك القيود الغذائية، وإمكانية الوصول لذوي الإعاقة، وأي احتياجات شخصية أخرى. يرجى ذكر متطلباتك عند الحجز وسنبذل قصارى جهدنا لتلبيتها."
  },
  {
    question: "ما الذي يشمله سعر باقة العمرة؟",
    answer:
      "بشكل عام، تشمل باقاتنا معالجة التأشيرة، الطيران، الإقامة في الفنادق، النقل داخل السعودية، والوجبات. تختلف التفاصيل المحددة حسب الباقة، لذا يرجى مراجعة وصف الباقة أو التواصل معنا لمزيد من المعلومات."
  },
  {
    question: "متى يجب أن أحجز رحلة العمرة؟",
    answer:
      "نوصي بالحجز قبل موعد الرحلة بأسبوعين على الأقل، خاصة في المواسم المزدحمة، لضمان أفضل الأسعار والتوافر. ومع ذلك، يمكننا استيعاب الحجوزات في اللحظة الأخيرة حسب التوافر."
  },
  {
    question: "هل يوجد مرشد أو مساعدة متاحة خلال رحلة العمرة؟",
    answer:
      "نعم، تشمل باقاتنا خدمات مرشدين ذوي خبرة على دراية بمناسك العمرة ويمكنهم تقديم المساعدة خلال رحلتك."
  },
  {
    question: "ما هي سياسة الإلغاء الخاصة بكم؟",
    answer:
      "تختلف سياسة الإلغاء حسب الباقة. بشكل عام، الإلغاءات التي تتم خلال فترة معينة قبل السفر قد تكون مؤهلة لاسترداد كامل أو جزئي. يرجى مراجعة الشروط والأحكام الخاصة بباقتك للحصول على تفاصيل كاملة."
  },
  {
    question: "كيف أستعد لرحلة العمرة؟",
    answer:
      "نوفر لجميع المسافرين دليلاً شاملاً حول كيفية الاستعداد للعمرة، يشمل الوثائق المطلوبة، الملابس الموصى بها، والاستعداد الروحي. فريقنا متاح أيضاً للإجابة على أي أسئلة قد تكون لديك."
  },
  {
    question: "هل خيارات الطيران والإقامة مرنة؟",
    answer:
      "نعم، نقدم مجموعة من خيارات الطيران والإقامة لتناسب التفضيلات والميزانيات المختلفة. يمكنك اختيار شركة الطيران والفندق عند حجز باقتك."
  },
  {
    question: "كيف يمكنني التواصل معكم لمزيد من الأسئلة؟",
    answer:
      "يمكنك التواصل معنا من خلال نموذج التواصل على موقعنا، البريد الإلكتروني، أو الهاتف. فريق خدمة العملاء لدينا متاح على مدار الساعة طوال أيام الأسبوع لمساعدتك في أي استفسارات."
  }
];

const ArFaq = () => {

  useEffect(() => {
    const canonicalUrl = `${CLIENT_BASE_PATH}/ar/faq`;
    setMeta(
      "الأسئلة الشائعة عن تاكسي الحج والعمرة | الحرمين كاب",
      "اعثر على إجابات حول حجوزات الحرمين كاب، نقل مطارات السعودية، تاكسي مكة والمدينة، رحلات الزيارة، ونقل الفنادق.",
      canonicalUrl,
      undefined,
      {
        keywords: "أسئلة الحرمين كاب الشائعة, أسئلة تاكسي العمرة, مساعدة حجز تاكسي الحج, أسئلة نقل مطار السعودية",
        locale: "ar",
        alternateUrl: `${CLIENT_BASE_PATH}/faq`,
        structuredData: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqItems.map(item => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.answer
            }
          }))
        }
      }
    );
  }, []);


  return (
    <>
      <ArabicBreadcrumbs title="الأسئلة الشائعة" />
      <section className="section faq-section">
        <div className="container">
          <div className="faq-info">
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqOne"
                  aria-expanded="false"
                >
                  كيف يمكنني حجز رحلة العمرة معكم؟
                </Link>
              </h4>
              <div id="faqOne" className="card-collapse collapse">
                <p>
                  يمكنك حجز رحلتك من خلال موقعنا الإلكتروني أو تطبيق الهاتف. اختر الباقة التي تريدها، أدخل بياناتك، واختر طريقة الدفع. سيتم إرسال تأكيد الحجز إليك فوراً بعد إتمام الحجز.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqTwo"
                  aria-expanded="false"
                >
                  ما أنواع الباقات التي تقدمونها لرحلة العمرة؟
                </Link>
              </h4>
              <div id="faqTwo" className="card-collapse collapse">
                <p>
                  نقدم مجموعة متنوعة من الباقات لتناسب احتياجات وميزانيات مختلفة، تشمل باقات أساسية ومميزة وفاخرة. تشمل كل باقة السفر والإقامة ومعالجة التأشيرة، مع تفاصيل كاملة متوفرة على موقعنا.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqThree"
                  aria-expanded="false"
                >
                  هل يمكنكم تلبية الطلبات أو الاحتياجات الخاصة؟
                </Link>
              </h4>
              <div id="faqThree" className="card-collapse collapse">
                <p>
                  نعم، نسعى لتلبية جميع الطلبات الخاصة، بما في ذلك القيود الغذائية، وإمكانية الوصول لذوي الإعاقة، وأي احتياجات شخصية أخرى. يرجى ذكر متطلباتك عند الحجز وسنبذل قصارى جهدنا لتلبيتها.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqFour"
                  aria-expanded="false"
                >
                  ما الذي يشمله سعر باقة العمرة؟
                </Link>
              </h4>
              <div id="faqFour" className="card-collapse collapse">
                <p>
                  بشكل عام، تشمل باقاتنا معالجة التأشيرة، الطيران، الإقامة في الفنادق، النقل داخل السعودية، والوجبات. تختلف التفاصيل المحددة حسب الباقة، لذا يرجى مراجعة وصف الباقة أو التواصل معنا لمزيد من المعلومات.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqFive"
                  aria-expanded="false"
                >
                  متى يجب أن أحجز رحلة العمرة؟
                </Link>
              </h4>
              <div id="faqFive" className="card-collapse collapse">
                <p>
                  نوصي بالحجز قبل موعد الرحلة بأسبوعين على الأقل، خاصة في المواسم المزدحمة، لضمان أفضل الأسعار والتوافر. ومع ذلك، يمكننا استيعاب الحجوزات في اللحظة الأخيرة حسب التوافر.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqSix"
                  aria-expanded="false"
                >
                  هل يوجد مرشد أو مساعدة متاحة خلال رحلة العمرة؟
                </Link>
              </h4>
              <div id="faqSix" className="card-collapse collapse">
                <p>
                  نعم، تشمل باقاتنا خدمات مرشدين ذوي خبرة على دراية بمناسك العمرة ويمكنهم تقديم المساعدة خلال رحلتك.
                </p>
              </div>
            </div>
            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqSeven"
                  aria-expanded="false"
                >
                  ما هي سياسة الإلغاء الخاصة بكم؟
                </Link>
              </h4>
              <div id="faqSeven" className="card-collapse collapse">
                <p>
                  تختلف سياسة الإلغاء حسب الباقة. بشكل عام، الإلغاءات التي تتم خلال فترة معينة قبل السفر قد تكون مؤهلة لاسترداد كامل أو جزئي. يرجى مراجعة الشروط والأحكام الخاصة بباقتك للحصول على تفاصيل كاملة.
                </p>
              </div>
            </div>

            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqEight"
                  aria-expanded="false"
                >
                  كيف أستعد لرحلة العمرة؟
                </Link>
              </h4>
              <div id="faqEight" className="card-collapse collapse">
                <p>
                  نوفر لجميع المسافرين دليلاً شاملاً حول كيفية الاستعداد للعمرة، يشمل الوثائق المطلوبة، الملابس الموصى بها، والاستعداد الروحي. فريقنا متاح أيضاً للإجابة على أي أسئلة قد تكون لديك.
                </p>
              </div>
            </div>

            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqNine"
                  aria-expanded="false"
                >
                  هل خيارات الطيران والإقامة مرنة؟
                </Link>
              </h4>
              <div id="faqNine" className="card-collapse collapse">
                <p>
                  نعم، نقدم مجموعة من خيارات الطيران والإقامة لتناسب التفضيلات والميزانيات المختلفة. يمكنك اختيار شركة الطيران والفندق عند حجز باقتك.
                </p>
              </div>
            </div>

            <div className="faq-card bg-white" data-aos="fade-down">
              <h4 className="faq-title">
                <Link
                  className="collapsed"
                  data-bs-toggle="collapse"
                  to="#faqTen"
                  aria-expanded="false"
                >
                  كيف يمكنني التواصل معكم لمزيد من الأسئلة؟
                </Link>
              </h4>
              <div id="faqTen" className="card-collapse collapse">
                <p>
                  يمكنك التواصل معنا من خلال نموذج التواصل على موقعنا، البريد الإلكتروني، أو الهاتف. فريق خدمة العملاء لدينا متاح على مدار الساعة طوال أيام الأسبوع لمساعدتك في أي استفسارات.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ArFaq;
